import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EntityCardContainer,
  EntityCardItem,
} from '../../../entity/components/EntityCardComponents';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import styles from './lawyer_retired.module.scss';
import { LawyerContext } from '../LawyerContext';

export const LawyerRetired: FC = () => {
  const {
    lawyerInfos: { barreau },
    lawyerName,
    lawyerHasRetired,
  } = useContext(LawyerContext);
  if (!lawyerHasRetired) return null;
  return (
    <EntityCardContainer>
      <EntityCardItem>
        <MaterialIcon name="not_interested" className={styles.icon} />
        <b>
          {lawyerName}{' '}
          {barreau === 'Avocat aux conseils' ? (
            <FormattedMessage id="app.pages.lawyer.retired.consulting" />
          ) : (
            <FormattedMessage
              id="app.pages.lawyer.retired.bar"
              values={{ bar: barreau }}
            />
          )}
        </b>
      </EntityCardItem>
    </EntityCardContainer>
  );
};
